import { FunctionalApproval } from '@lendiodevs/lendio-js-utilities/dist/calculator/functional-approval';
import { Approval } from '@lendiodevs/lendio-js-utilities/dist/calculator/types/approval';

const AchApprovalSample = {
  'id': 15851463,
  'name': null,
  'dealId': 5055620,
  'calculationType': 'standard',
  'stability': 'hard',
  'termType': 'months',
  'expires': '2025-01-28 00:00:00',
  'position': 1,
  'netMinimum': 2,
  'pointsTradable': 0,
  'payoffAmount': 0,
  'withheldAmount': 0,
  'notes': '[ApprovalSeeder] This is a test approval',
  'offerLink': 'https://lendersite.example/offers/23138291',
  'hasVariablePayment': null,
  'isTest': 0,
  'publishedToBorrower': null,
  'publishedByLenderUserId': null,
  'created': '2025-01-27 13:44:01',
  'modified': '2025-01-27 13:44:01',
  'deleted': null,
  'options': [
    {
      'id': 158522485,
      'approvalId': 15851463,
      'term': 7,
      'paymentFrequency': 'daily',
      'lenderOptionId': null,
      'buyRate': 1.25,
      'variablePercentOfRevenue': null,
      'payments': '212.9170',
      'created': '2025-01-27 13:44:02',
      'modified': '2025-01-27 13:44:02',
      'deleted': null,
      'customCalculatorParams': null,
      'limits': {
        'amount': {
          'min': 0,
          'max': 44800
        },
        'points': {
          'min': 0,
          'max': 12
        },
        'originationPercent': {
          'min': 2.5,
          'max': 2.5
        },
        'originationAmount': {
          'min': 300,
          'max': 0
        },
        'paymentAmountMax': 299.4
      }
    }
  ],
  'loanProductName': 'ACH Cashflow Loan',
  'loanProductRoundingStrategy': 'halfEven',
  'loanProductLenderId': 224,
  'loanProductId': 38,
  'calculatorConfig': {
    'drawFeeAmount': 'DEFAULT',
    'disbursement': 'DEFAULT',
    'annualInterestRate': 'DEFAULT',
    'payback': 'DEFAULT',
    'totalInterest': 'DEFAULT',
    'totalCostOfCapital': 'DEFAULT',
    'apr': 'DEFAULT',
    'centsOnTheDollar': 'DEFAULT',
    'paymentSchedule': {
      'scheduleRowPaymentAmount': 'DEFAULT',
      'scheduleRowInterestAmount': 'DEFAULT',
      'scheduleRowPrincipalAmount': 'DEFAULT',
      'scheduleRowEndBalance': 'DEFAULT'
    },
    'buyRate': 'DEFAULT'
  },
  'benefits': [],
  'points': '0.00',
  'loanProductLender': 'On Deck Capital',
  'loanProductType': 'alternative',
  'requestNames': {
    'nonConditional': [
      'Voided Check - voided check needed',
      'Driver\'s License - driver\'s license needed',
      'Valid Phone Number - Valid Phone Number',
      'Alternative Phone Number - Alternative Phone Number',
      'Use of funds',
      'Voided Check - Please upload a voided check from your business bank account.',
      'Driver’s License - Please upload a copy of your driver\'s license.',
      'Proof of Business Address (Recent Business Utility Bill, Current Business License, or Executed Business Lease)',
      'Bank Verification',
      'Tax Return - Business Tax Return document for specified year.'
    ],
    'conditional': []
  },
  'loanProductCategoryType': 'ach'
};

export const AchFunctionalApprovalSample = new FunctionalApproval(AchApprovalSample as unknown as Approval);
